export default "__VITE_ASSET__9627dd57__"